module.exports = __webpack_public_path__ + "static/media/chevron-down-pa.04bfc721.svg";